import { datadogRum } from '@datadog/browser-rum';

const PII_CHECKS: { name: string; keywords: string[]; regex?: RegExp }[] = [
  {
    name: 'EMAIL',
    keywords: ['email'],
    regex: /\b[A-Z\d._%+-]+@[A-Z\d.-]+\.[A-Z]{2,}\b/gi,
  },
  {
    name: 'PASSWORD',
    keywords: ['pass'],
  },
  {
    name: 'NAME',
    keywords: ['name'],
  },
  {
    name: 'PHONE',
    keywords: ['tel', 'phone', 'mobile'],
    regex: /[+]?[(]?\d{3}[)]?[-\s.]?\d{3}[-\s.]?\d{4,6}/g,
  },
  {
    name: 'ZIP CODE',
    keywords: ['zip'],
  },
  {
    name: 'CREDIT CARD',
    keywords: ['credit', 'card'],
    regex: /\b(?:\d[ -]*?){13,16}\b/g,
  },
  {
    name: 'ACCOUNT NUMNER',
    keywords: ['accountnumber', 'confirmAccountnumber'],
  },
  {
    name: 'ROUTING NUMNER',
    keywords: ['routingnumber'],
  },
];

export const redactPIIForString = (value: string): string => {
  let newValue = value;
  PII_CHECKS.forEach((check) => {
    if (check.regex && value.match(check.regex)) {
      newValue = value.replace(check.regex, `[REDACTED ${check.name}]`);
    }
  });
  return newValue;
};

export const redactPIIForFormData = (formData: Record<string, unknown>): Record<string, unknown> => {
  const newFormData = { ...formData };
  try {
    Object.entries(newFormData).forEach(([key, value]: [key: string, value: unknown]) => {
      if (value) {
        const type = typeof value;
        switch (type) {
          case 'string':
          case 'number': {
            let newString = String(value);
            PII_CHECKS.forEach((check) => {
              check.keywords.forEach((keyword) => {
                if (key.toLowerCase().includes(keyword)) {
                  newString = `[REDACTED ${check.name}]`;
                }
              });
            });
            // eslint-disable-next-line eqeqeq
            if (newString == value) {
              newString = redactPIIForString(newString);
            }
            newFormData[key] = newString;
            break;
          }
          case 'object':
            newFormData[key] = redactPIIForFormData(value as Record<string, unknown>);
            if (Array.isArray(value)) {
              newFormData[key] = Object.values(newFormData[key] as Record<string, unknown>);
            }
            break;
          default:
            break;
        }
      }
    });
  } catch (e) {
    datadogRum.addError('unexpected error in redactPIIForFormData', e);
  }
  return newFormData;
};
